module.exports = __webpack_public_path__ + "static/a-xx-223-art-a5807fe29688df99f07259e0f7a7d788.jpg";